import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'client/reducers/pageReducer'

// NOTE: @deprecated use the usePage instead (client/store/index.ts)
export default function usePresentPage(selector) {
  return useSelector(state => selector(state.page.present), shallowEqual)
}

export { selectors }
